"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Department = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const org_vertical_entity_1 = require("./org-vertical.entity");
let Department = class Department {
    constructor(id, name, verticalId, description, createdAt, updatedAt, createdBy, updatedBy) {
        this.id = id;
        this.name = name;
        this.verticalId = verticalId;
        this.description = description;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.Department = Department;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Department.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], Department.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "vertical_id" }),
    tslib_1.__metadata("design:type", Number)
], Department.prototype, "verticalId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "text" }),
    tslib_1.__metadata("design:type", String)
], Department.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Department.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Department.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], Department.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], Department.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => org_vertical_entity_1.OrgVertical, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "vertical_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof org_vertical_entity_1.OrgVertical !== "undefined" && org_vertical_entity_1.OrgVertical) === "function" ? _e : Object)
], Department.prototype, "vertical", void 0);
exports.Department = Department = tslib_1.__decorate([
    (0, typeorm_1.Entity)("department"),
    tslib_1.__metadata("design:paramtypes", [Number, String, Number, String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, String, String])
], Department);
